import React, {useState, useEffect, useCallback} from 'react';
import {API_ENDPOINTS} from '../../../apiConfig';
import API from '../../../utils/API';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import Forms from '../../../components/Forms';
import DeleteIconButton from "../../../components/Forms/DeleteIconButton";
import EditIconButton from "../../../components/Forms/EditIconButton";
import {useModal} from '../../../contexts/ModalContext';
import UserModal from '../../../components/UserModal';
import AdminDataView from "../../../components/AdminDataView";

const Users = () => {
    const [users, setUsers] = useState([]);
    const {t} = useTranslation();
    const {openModal, confirm} = useModal();

    const fetchUsers = useCallback(async () => {
        try {
            const res = await API.get(API_ENDPOINTS.user.list);
            setUsers(res.data || []);
        } catch (e) {
            console.error('Failed to fetch users:', e);
        }
    }, []);

    useEffect(() => { fetchUsers(); }, [fetchUsers]);

    const confirmDeleteUser = async (user) => {
        const msg = t('users.confirmDeletionMessage', { name: `${user.name} ${user.surname}` });
        const ok = await confirm(msg, {});
        if (ok === true) {
            try {
                await API.delete(API_ENDPOINTS.user.delete(user._id));
                setUsers(prev => prev.filter(u => u._id !== user._id));
            } catch (e) {
                console.error('Failed to delete user:', e);
            }
        }
    };

    const openUserModal = (user) => {
        openModal(
            UserModal,
            { user, onUserUpdate: fetchUsers },
            { title: user ? t('users.editUser') : t('users.addUser') }
        );
    };

    const columns = [
        {
            key: 'name',
            name: t('name'),
            width: '28%',
            renderCell: ({row}) => `${row.name} ${row.surname}`
        },
        {
            key: 'email',
            name: 'Email',
            width: '22%',
            renderCell: ({row}) => row.email
        },
        {
            key: 'profileList',
            name: t('users.profiles'),
            width: '20%',
            renderCell: ({row}) => (row.profileList || []).join(', ')
        },
        {
            key: 'lastSignIn',
            name: t('users.lastSignIn'),
            width: '15%',
            renderCell: ({row}) => row.lastSignIn ? moment(row.lastSignIn).format('DD.MM.YYYY HH:mm') : '-'
        },
        {
            key: 'createdAt',
            name: t('createdAt'),
            width: '15%',
            renderCell: ({row}) => row.createdAt ? moment(row.createdAt).format('DD.MM.YYYY HH:mm') : '-'
        },
        {
            key: 'actions',
            name: 'Akce',
            width: '10%',
            renderCell: ({row}) => (
                <div className="flex items-center justify-end h-full w-full">
                    <EditIconButton title="Upravit uživatele" onClick={() => openUserModal(row)}/>
                    <DeleteIconButton title="Smazat uživatele" onClick={() => confirmDeleteUser(row)}/>
                </div>
            )
        }
    ].map(c => ({...c, resizable: true}));

    return (
        <div>
            <Forms.Button label={t('users.addUser')} onClick={() => openUserModal()} className="mb-8"/>
            <AdminDataView section="users" rows={users} columns={columns}/>
        </div>
    );
};

export default Users;
